import { MFAUser } from '@organization/api/requests'
import { ConditionalText, DateTimeCell, TableActions } from '@shared/components'
import { Badge, Tag, Tooltip } from 'antd'
import { ColumnProps } from 'antd/es/table'
import { TFunction } from 'i18next'
import { Edit2 } from 'iconsax-react'

import { ConfigMFASwitchProperty } from '../ConfigMFASwitchProperty'

export const getConfigMFATableColumns = (
  setEditModal: (id: string) => void,
  t: TFunction
): ColumnProps<MFAUser>[] => [
  {
    title: t('table.user'),
    dataIndex: 'email',
    key: 'email',
    render: (value) => (
      <ConditionalText condition={!!value}>{value}</ConditionalText>
    )
  },
  {
    title: t('table.backup_codes'),
    dataIndex: ['mfa_config', 'backup_codes'],
    key: 'backup_codes',
    render: (codes) => (
      <ConditionalText condition={!!codes?.length}>
        <Badge count={codes?.length ? `+${codes?.length}` : undefined}>
          <Tooltip
            trigger={codes?.length > 1 ? 'hover' : 'contextMenu'}
            title={codes?.join(', ')}
          >
            <Tag>{codes?.[0]}</Tag>
          </Tooltip>
        </Badge>
      </ConditionalText>
    )
  },
  {
    title: t('table.email_enabled'),
    dataIndex: ['mfa_config', 'email_enabled'],
    key: 'email_enabled',
    align: 'center',
    render: (value, record) => (
      <ConfigMFASwitchProperty
        data={record}
        checked={!!value}
        disabled={!record.mfa_config}
        updateBody={(checked) => ({ email_enabled: checked })}
      />
    )
  },
  {
    title: t('table.enabled'),
    dataIndex: ['mfa_config', 'enabled'],
    key: 'enabled',
    align: 'center',
    render: (value, record) => (
      <ConfigMFASwitchProperty
        data={record}
        checked={!!value}
        updateBody={(checked) => ({ enabled: checked })}
      />
    )
  },
  {
    title: t('table.preferred_method'),
    dataIndex: ['mfa_config', 'preferred_method'],
    key: 'preferred_method',
    render: (method) => (
      <ConditionalText condition={!!method}>
        {t(`table.${method}`)}
      </ConditionalText>
    )
  },
  {
    title: t('table.used_backup_codes'),
    dataIndex: ['mfa_config', 'used_backup_codes'],
    key: 'used_backup_codes',
    render: (codes) => (
      <ConditionalText condition={!!codes?.length}>
        <Badge count={codes?.length ? `+${codes?.length}` : undefined}>
          <Tooltip
            trigger={codes?.length > 1 ? 'hover' : 'contextMenu'}
            title={codes?.join(', ')}
          >
            <Tag>{codes?.[0]}</Tag>
          </Tooltip>
        </Badge>
      </ConditionalText>
    )
  },
  {
    title: t('table.date_created'),
    dataIndex: ['mfa_config', 'created_at'],
    key: 'created_at',
    render: (time) => <DateTimeCell date={time} />
  },
  {
    title: t('table.date_updated'),
    dataIndex: ['mfa_config', 'updated_at'],
    key: 'updated_at',
    render: (time) => <DateTimeCell date={time} />
  },
  {
    key: 'actions',
    align: 'center',
    dataIndex: ['mfa_config', 'id'],
    fixed: 'right',
    width: 50,
    render: (id) => (
      <ConditionalText condition={!!id}>
        <TableActions
          options={[
            {
              label: t('edit_backup_codes'),
              key: 'edit',
              icon: <Edit2 size={16} />,
              onClick: () => setEditModal(id)
            }
          ]}
        />
      </ConditionalText>
    )
  }
]
